module.exports = new __parcel__URL__("graph.a9178f19.svg").toString();